// import React, { useEffect, useMemo, useRef, useState } from "react";

// /**
//  * Cabil AI Chat (Themed + Scroll-locked)
//  * - Theme: gradient from[#EE5F2B] to[#2A3A54]
//  * - Only messages area scrolls; outer container is overflow-hidden
//  * - Responsive layout (buttons wrap, pills collapse nicely)
//  * - Original WS instrumentation preserved
//  */

// const DOTS = [0, 1, 2];

// function slugify(s = "") {
//   return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
// }
// function todayISO() {
//   const d = new Date();
//   const yyyy = d.getFullYear();
//   const mm = `${d.getMonth() + 1}`.padStart(2, "0");
//   const dd = `${d.getDate()}`.padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`;
// }

// export default function CabilAIChat({
//   user = {
//     // user_id: "u123",
//     // user_name: "Saad",
//     // profile: {
//     //   name: "Saad",
//     //   user_type: "professional", // MUST be exactly this
//     //   degree_subject: "Computer Science",
//     //   years_experience: 5,
//     //   experience: "Worked as Full Stack Developer",
//     //   skills: ["React", "Node.js"],
//     // },
//   },
//   wsBase = "wss://ai.cabil.co/ws/qa_chat",
//   includeDateSuffix = false,
// }) {
//   const [messages, setMessages] = useState([
//     {
//       id: "hello",
//       role: "assistant",
//       content:
//         "Hey! I’m your Cabil AI Mentor. Ask me anything about careers, skills, or your learning path. 😊",
//       ts: Date.now(),
//     },
//   ]);
//   const [value, setValue] = useState("");
//   const [status, setStatus] = useState("disconnected");
//   const [typing, setTyping] = useState(false);
//   const [retryCount, setRetryCount] = useState(0);
//   const [showDebug, setShowDebug] = useState(false);
//   const [lastEvent, setLastEvent] = useState(null);
//   const [lastRaw, setLastRaw] = useState("");
//   const [rawToSend, setRawToSend] = useState(
//     JSON.stringify(
//       {
//         type: "user_message",
//         text: "test message",
//         user_id: user.user_id,
//         user_name: user.user_name,
//       },
//       null,
//       2
//     )
//   );

//   const wsRef = useRef(null);
//   const listRef = useRef(null);
//   const typingTimer = useRef(null);
//   const manualClose = useRef(false);
//   const heartbeat = useRef(null);

//   const room = useMemo(() => {
//     const uname = slugify(user?.user_name || "user");
//     const uid = slugify(user?.user_id || "id");
//     const dateSuffix = includeDateSuffix ? `_${todayISO()}` : "";
//     return `cabil_${uname}_${uid}${dateSuffix}`;
//   }, [user, includeDateSuffix]);

//   const wsUrl = `${wsBase}/${room}`;

//   // auto-scroll only the message list
//   useEffect(() => {
//     if (!listRef.current) return;
//     listRef.current.scrollTop = listRef.current.scrollHeight;
//   }, [messages, typing]);

//   useEffect(() => {
//     connect();
//     return () => {
//       manualClose.current = true;
//       clearInterval(heartbeat.current);
//       if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//         wsRef.current.close(1000, "Component unmount");
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [wsUrl]);

//   function log(...args) {
//     // eslint-disable-next-line no-console
//     console.log("%c[WS]", "color:#0aa; font-weight:bold;", ...args);
//   }

//   function connect() {
//     manualClose.current = false;
//     setStatus("connecting");
//     setLastEvent({ type: "connecting", ts: Date.now(), url: wsUrl });
//     log("connecting →", wsUrl);

//     try {
//       const ws = new WebSocket(wsUrl);
//       wsRef.current = ws;

//       ws.onopen = () => {
//         setStatus("connected");
//         setRetryCount(0);
//         setLastEvent({ type: "open", ts: Date.now() });
//         log("open");

//         // heartbeat
//         clearInterval(heartbeat.current);
//         heartbeat.current = setInterval(() => {
//           safeSend({ type: "ping", ts: Date.now() });
//         }, 25000);

//         // init
//         const initPayload = {
//           type: "init",
//           user_id: user.user_id,
//           user_name: user.user_name,
//           profile: {
//             name: user.profile?.name || user.user_name,
//             user_type: "professional", // MUST be exactly this
//             degree_subject: user.profile?.degree_subject || "",
//             years_experience: user.profile?.years_experience ?? 0,
//             experience: user.profile?.experience || "",
//             skills: Array.isArray(user.profile?.skills) ? user.profile.skills : [],
//           },
//         };
//         console.log("initPayload", initPayload);  
//         safeSend(initPayload);
//         safeSend({ type: "meta", event: "hello_from_client" });
//       };

//       ws.onmessage = (evt) => {
//         setLastRaw(String(evt.data));
//         log("message(raw) →", evt.data);

//         try {
//           const data = JSON.parse(evt.data);

//           if (data?.type === "typing") {
//             setTyping(true);
//             clearTimeout(typingTimer.current);
//             typingTimer.current = setTimeout(() => setTyping(false), 1500);
//             return;
//           }

//           if (typeof data === "string") {
//             pushMsg({ role: "assistant", content: data });
//             return;
//           }

//           if (data?.role && data?.content !== undefined) {
//             pushMsg({ role: data.role, content: String(data.content) });
//             return;
//           }

//           const text = data?.message ?? data?.reply ?? data?.answer ?? data?.text;
//           if (text !== undefined) {
//             pushMsg({ role: "assistant", content: String(text) });
//             return;
//           }

//           pushMsg({
//             role: "assistant",
//             content: "Received: " + JSON.stringify(data, null, 2),
//           });
//         } catch {
//           pushMsg({ role: "assistant", content: String(evt.data) });
//         }
//       };

//       ws.onerror = (err) => {
//         setLastEvent({ type: "error", ts: Date.now(), err });
//         log("error →", err);
//       };

//       ws.onclose = (e) => {
//         clearInterval(heartbeat.current);
//         setStatus("disconnected");
//         setLastEvent({
//           type: "close",
//           ts: Date.now(),
//           code: e.code,
//           reason: e.reason,
//           wasClean: e.wasClean,
//         });
//         log(
//           "close →",
//           `code=${e.code}, reason=${e.reason || "(none)"}, clean=${e.wasClean}`
//         );

//         if (!manualClose.current) {
//           const next = Math.min(5, retryCount + 1);
//           setRetryCount(next);
//           const delay = Math.min(15000, 1000 * Math.pow(2, next - 1));
//           log(`reconnect in ${delay}ms (attempt ${next})`);
//           setTimeout(() => connect(), delay);
//         }
//       };
//     } catch (e) {
//       log("connect threw →", e);
//       setStatus("disconnected");
//     }
//   }

//   function pushMsg({ role, content }) {
//     setMessages((prev) => [
//       ...prev,
//       { id: `${Date.now()}-${Math.random()}`, role, content, ts: Date.now() },
//     ]);
//   }

//   function safeSend(obj) {
//     try {
//       const json = JSON.stringify(obj);
//       wsRef.current?.send(json);
//       log("send →", json);
//     } catch (e) {
//       log("send failed →", e);
//     }
//   }

//   function sendUserMessage(text) {
//     if (!text.trim()) return;
//     pushMsg({ role: "user", content: text });

//     const envelopes = [
//       { type: "message", message: text, uid: user.user_id, name: user.user_name },
//       { role: "user", content: text, user_id: user.user_id, user_name: user.user_name },
//     ];

//     envelopes.forEach((env, idx) => setTimeout(() => safeSend(env), idx * 80));
//   }

//   function onSubmit(e) {
//     e.preventDefault();
//     const text = value.trim();
//     if (!text) return;
//     setValue("");
//     sendUserMessage(text);
//   }

//   function forceReconnect() {
//     manualClose.current = false;
//     try {
//       wsRef.current?.close(1000, "Manual reconnect");
//     } catch {}
//     connect();
//   }

//   const quickPills = [
//     "Suggest a 30-day skill plan",
//     "Review my resume highlights",
//     "What roles fit my skills?",
//     "Mock interview: React + Node",
//   ];

//   return (
//     // Lock the page scroll here; only inner message list will scroll
//     <div className="w-full h-[calc(80vh-0px)] overflow-hidden">
//       <div className="h-full max-w-5xl mx-auto px-3 sm:px-6">
//         {/* Card container fills all available height */}
//         <div className="relative h-full bg-white/80 backdrop-blur rounded-3xl shadow-xl border border-gray-100 overflow-hidden flex flex-col">
//           {/* Header with brand gradient */}
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 sm:px-8 py-4 border-b bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center font-bold">
//                 AI
//               </div>
//               <div>
//                 <p className="text-lg font-semibold leading-none">Cabil AI Mentor</p>
//                 <p className="text-[11px] opacity-90">
//                   {/* Room: <span className="font-medium">{room}</span> */}
//                 </p>
//               </div>
//             </div>

//             <div className="flex items-center gap-2">
//               <span
//                 className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold`}
//                 title={wsUrl}
//                 style={{ background: "rgba(255,255,255,0.18)" }}
//               >
//                 <span
//                   className={`mr-1.5 inline-block h-2 w-2 rounded-full ${
//                     status === "connected"
//                       ? "bg-green-300"
//                       : status === "connecting"
//                       ? "bg-yellow-300"
//                       : "bg-red-300"
//                   }`}
//                 />
//                 {status}
//               </span>

//               <button
//                 onClick={forceReconnect}
//                 className="hidden sm:inline-flex text-xs font-semibold bg-white/20 hover:bg-white/30 active:scale-95 px-3 py-1.5 rounded-full"
//               >
//                 Reconnect
//               </button>

//               {/* <button
//                 onClick={() => setShowDebug((s) => !s)}
//                 className="text-xs font-semibold bg-white/20 hover:bg-white/30 active:scale-95 px-3 py-1.5 rounded-full"
//                 title="Toggle Debug"
//               >
//                 {showDebug ? "Hide Debug" : "Show Debug"}
//               </button> */}
//             </div>
//           </div>

//           {/* Body column — flex so only the list scrolls */}
//           <div className="flex-1 flex flex-col min-h-0">
//             {/* Pills */}
//             <div className="px-4 sm:px-8 pt-3">
//               <div className="flex max-md:hidden flex-wrap gap-2">
//                 {quickPills.map((q) => (
//                   <button
//                     key={q}
//                     onClick={() => {
//                       setValue(q);
//                       setTimeout(() => {
//                         sendUserMessage(q);
//                         setValue("");
//                       }, 10);
//                     }}
//                     className="text-xs sm:text-sm px-3 py-1.5 rounded-full border transition
//                                bg-white text-gray-800 border-gray-200 hover:border-[#EE5F2B]
//                                hover:text-[#2A3A54]"
//                   >
//                     {q}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             {/* Message list — the ONLY scrolling region */}
//             <div
//               ref={listRef}
//               className="flex-1 overflow-y-auto px-3 sm:px-8 py-4 space-y-3 scroll-smooth"
//             >
//               {messages.map((m) => (
//                 <ChatBubble key={m.id} role={m.role} content={m.content} />
//               ))}
//               {typing && <TypingBubble />}
//             </div>

//             {/* Composer — sticky within the card, not the page */}
//             <form onSubmit={onSubmit} className="px-3 sm:px-6 pb-4">
//               <div className="flex items-end gap-2 bg-white rounded-2xl border border-gray-200 shadow-sm p-2">
//                 <textarea
//                   value={value}
//                   onChange={(e) => setValue(e.target.value)}
//                   rows={1}
//                   placeholder="Ask about careers, learning paths, resume tips…"
//                   className="flex-1 resize-none outline-none bg-transparent px-2 py-2 text-sm sm:text-base"
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" && !e.shiftKey) {
//                       e.preventDefault();
//                       onSubmit(e);
//                     }
//                   }}
//                 />
//                 <button
//                   type="submit"
//                   className="shrink-0 inline-flex items-center gap-2 text-white font-semibold px-4 py-2 rounded-xl shadow hover:opacity-95 disabled:opacity-60
//                              bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                   disabled={status !== "connected"}
//                   title={status !== "connected" ? "Connecting…" : "Send"}
//                 >
//                   <svg
//                     className="w-4 h-4 -ml-0.5"
//                     fill="none"
//                     stroke="currentColor"
//                     strokeWidth="2"
//                     viewBox="0 0 24 24"
//                   >
//                     <path d="M22 2L11 13" />
//                     <path d="M22 2L15 22L11 13L2 9L22 2Z" />
//                   </svg>
//                   <span className="hidden sm:inline">Send</span>
//                 </button>
//               </div>
//               <p className="mt-2 text-[11px] text-gray-400 px-2 truncate">
//                 {/* Connected to <span className="font-medium">{wsUrl}</span> */}
//               </p>
//             </form>
//           </div>

//           {/* Debug drawer — absolutely positioned; it won't force page scroll */}
//           {showDebug && (
//             <div className="absolute right-3 bottom-3 w-[min(520px,94%)] max-h-[65%] overflow-auto bg-white border border-gray-200 shadow-2xl rounded-2xl p-3">
//               <p className="text-sm font-semibold mb-2">Debug</p>
//               <div className="text-xs text-gray-600 space-y-1 mb-3">
//                 <div>
//                   Status: <b>{status}</b>
//                 </div>
//                 <div>Retry: {retryCount}</div>
//                 <div>
//                   Last event:{" "}
//                   <code className="bg-gray-50 px-1 rounded">
//                     {JSON.stringify(lastEvent)}
//                   </code>
//                 </div>
//                 <div className="mt-1">
//                   Last raw message:
//                   <pre className="mt-1 bg-gray-50 rounded p-2 max-h-36 overflow-auto">
//                     {lastRaw || "(none)"}
//                   </pre>
//                 </div>
//                 <div className="flex flex-wrap gap-2 mt-2">
//                   <button
//                     className="text-xs px-3 py-1.5 rounded border border-gray-300 hover:bg-gray-50"
//                     onClick={() => navigator.clipboard.writeText(wsUrl)}
//                   >
//                     Copy WS URL
//                   </button>
//                   <button
//                     className="text-xs px-3 py-1.5 rounded border border-gray-300 hover:bg-gray-50"
//                     onClick={() => {
//                       safeSend({ type: "ping", ts: Date.now() });
//                     }}
//                   >
//                     Send ping
//                   </button>
//                 </div>
//               </div>

//               <div className="mt-2">
//                 <p className="text-xs font-semibold mb-1">Send raw JSON</p>
//                 <textarea
//                   className="w-full border rounded p-2 text-xs font-mono bg-gray-50"
//                   rows={6}
//                   value={rawToSend}
//                   onChange={(e) => setRawToSend(e.target.value)}
//                 />
//                 <div className="flex flex-wrap gap-2 mt-2">
//                   <button
//                     className="text-xs px-3 py-1.5 rounded text-white hover:opacity-95
//                                bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                     onClick={() => {
//                       try {
//                         const json = JSON.parse(rawToSend);
//                         safeSend(json);
//                       } catch {
//                         alert("Invalid JSON");
//                       }
//                     }}
//                   >connected
//                     Send JSON
//                   </button>
//                   <button
//                     className="text-xs px-3 py-1.5 rounded border border-gray-300 hover:bg-gray-50"
//                     onClick={() =>
//                       setRawToSend(
//                         JSON.stringify(
//                           {
//                             type: "user_message",
//                             text: "What roles fit my skills?",
//                             user_id: user.user_id,
//                             user_name: user.user_name,
//                           },
//                           null,
//                           2
//                         )
//                       )
//                     }
//                   >
//                     Load example
//                   </button>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function ChatBubble({ role, content }) {
//   const isUser = role === "user";
//   return (
//     <div className={`w-full flex ${isUser ? "justify-end" : "justify-start"}`}>
//       <div
//         className={`max-w-[88%] sm:max-w-[75%] rounded-2xl px-4 py-3 shadow ${
//           isUser
//             ? "text-white rounded-br-sm bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//             : "bg-white border border-gray-100 rounded-bl-sm"
//         }`}
//       >
//         {!isUser && (
//           <div className="text-[11px] font-semibold mb-1 text-[#2A3A54]">
//             Cabil Mentor
//           </div>
//         )}
//         <div
//           className={`text-sm leading-relaxed whitespace-pre-wrap ${
//             isUser ? "text-white" : "text-gray-800"
//           }`}
//         >
//           {content}
//         </div>
//       </div>
//     </div>
//   );
// }

// function TypingBubble() {
//   return (
//     <div className="w-full flex justify-start">
//       <div className="inline-flex items-center gap-1.5 bg-white border border-gray-100 rounded-2xl px-4 py-3 shadow">
//         {DOTS.map((i) => (
//           <span
//             key={i}
//             className="w-2 h-2 rounded-full bg-gray-300 animate-bounce"
//             style={{ animationDelay: `${i * 120}ms` }}
//           />
//         ))}
//       </div>
//     </div>
//   );
// }

// import React, { useEffect, useMemo, useRef, useState } from "react";
// import axios from "axios";
// import apiKey from "../../../config/apiKey";

// /**
//  * Cabil AI Chat — minimal payloads + compatible handshake
//  * - Room bootstrap: POST `${apiKey}/api/edolutions/rooms/create`
//  * - Save msg:       POST `${apiKey}/api/edolutions/messages`
//  * - WS path:        undergrad | grad | pro   (professional -> pro)
//  * - INIT frame on open with ONLY required profile fields.
//  * - User messages send {type:"user_message", text, message, user_id, user_name}.
//  */

// const DOTS = [0, 1, 2];

// function slugify(s = "") {
//   return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
// }
// function todayISO() {
//   const d = new Date();
//   const yyyy = d.getFullYear();
//   const mm = `${d.getMonth() + 1}`.padStart(2, "0");
//   const dd = `${d.getDate()}`.padStart(2, "0");
//   return `${yyyy}-${mm}-${dd}`;
// }

// export default function CabilAIChat({
//   user = {
//     // user_id: "u123",
//     // user_name: "Saad",
//     // profile: {
//     //   name: "Saad",
//     //   user_type: "undergrad",            // "undergrad" | "grad" | "professional"
//     //   degree_subject: "Computer Science",
//     //   university: "KU",
//     //   experience: "Worked as Full Stack Developer",
//     //   years_experience: 5,
//     //   skills: ["React", "Node.js"],
//     // },
//   },
//   wsBase = "wss://ai.cabil.co/ws/qa_chat",
//   includeDateSuffix = false,
// }) {
//   const apiBase = `${apiKey}/api`;

//   const [messages, setMessages] = useState([
//     {
//       id: "hello",
//       role: "assistant",
//       content:
//         "Hey! I’m your Cabil AI Mentor. Ask me anything about careers, skills, or your learning path. 😊",
//       ts: Date.now(),
//     },
//   ]);
//   const [value, setValue] = useState("");
//   const [status, setStatus] = useState("disconnected");
//   const [typing, setTyping] = useState(false);
//   const [retryCount, setRetryCount] = useState(0);
//   const [showDebug, setShowDebug] = useState();
//   const [lastEvent, setLastEvent] = useState(null);
//   const [lastRaw, setLastRaw] = useState("");
//   const [roomMeta, setRoomMeta] = useState(null);
//   const [initializing, setInitializing] = useState(true);

//   const wsRef = useRef(null);
//   const listRef = useRef(null);
//   const typingTimer = useRef(null);
//   const manualClose = useRef(false);
//   const heartbeat = useRef(null);

//   const room = useMemo(() => {
//     const uname = slugify(user?.user_name || "user");
//     const uid = slugify(user?.user_id || "id");
//     const dateSuffix = includeDateSuffix ? `_${todayISO()}` : "";
//     return `cabil_${uname}_${uid}${dateSuffix}`;
//   }, [user, includeDateSuffix]);

//   // normalize type for profile; map to WS path (professional -> pro)
//   const rawType = (user?.profile?.user_type || "undergrad").toLowerCase();
//   const normalizedType =
//     rawType === "professional" ? "professional" : rawType === "grad" ? "grad" : "undergrad";
//   const wsPath = normalizedType === "professional" ? "pro" : normalizedType; // undergrad|grad|pro
//   const wsUrl = `${wsBase}/${wsPath}`;

//   // EXACT minimal profile your bot wants
//   const contextPayload = useMemo(() => {
//     const skills = Array.isArray(user?.profile?.skills)
//       ? user.profile.skills
//       : String(user?.profile?.skills || "")
//           .split(",")
//           .map((s) => s.trim())
//           .filter(Boolean);

//     return {
//       name: user?.profile?.name || user?.user_name || "",
//       user_type: normalizedType, // undergrad | grad | professional
//       degree_subject: user?.profile?.degree_subject || "",
//       university: user?.profile?.university || "",
//       experience: user?.profile?.experience || "",
//       years_experience:
//         typeof user?.profile?.years_experience === "number"
//           ? user.profile.years_experience
//           : parseInt(user?.profile?.years_experience ?? 0, 10) || 0,
//       skills,
//     };
//   }, [user, normalizedType]);

//   // autoscroll in message list
//   useEffect(() => {
//     if (!listRef.current) return;
//     listRef.current.scrollTop = listRef.current.scrollHeight;
//   }, [messages, typing]);

//   // create-or-get room and load history
//   useEffect(() => {
//     let mounted = true;
//     (async () => {
//       try {
//         setInitializing(true);
//         const payload = { user_id: user.user_id, user_name: user.user_name };
//         const { data } = await axios.post(`${apiBase}/edolutions/rooms/create`, payload, {
//           headers: { "Content-Type": "application/json" },
//         });
//         if (!mounted) return;

//         setRoomMeta(data.room || null);

//         const hist = (data.messages || []).map((m) => ({
//           id: `db-${m.id}`,
//           role: m.user === "user" ? "user" : "assistant",
//           content: m.message,
//           ts: new Date(m.created_at).getTime(),
//         }));

//         setMessages((prev) => {
//           const greet = prev.length === 1 && prev[0].id === "hello" ? prev : [];
//           return [...greet, ...hist];
//         });
//       } catch (e) {
//         console.error("createOrGet room failed:", e?.response?.status, e?.response?.data || e.message);
//       } finally {
//         setInitializing(false);
//       }
//     })();
//     return () => {
//       mounted = false;
//     };
//   }, [apiBase, user.user_id, user.user_name]);

//   // WebSocket lifecycle
//   useEffect(() => {
//     if (!roomMeta) return;

//     connect();
//     return () => {
//       manualClose.current = true;
//       clearInterval(heartbeat.current);
//       if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
//         wsRef.current.close(1000, "Component unmount");
//       }
//     };
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [wsUrl, roomMeta?.id]);

//   function connect() {
//     manualClose.current = false;
//     setStatus("connecting");
//     setLastEvent({ type: "connecting", ts: Date.now(), url: wsUrl });

//     try {
//       const ws = new WebSocket(wsUrl);
//       wsRef.current = ws;

//       ws.onopen = () => {
//         setStatus("connected");
//         setRetryCount(0);
//         setLastEvent({ type: "open", ts: Date.now() });

//         clearInterval(heartbeat.current);
//         heartbeat.current = setInterval(() => safeSend({ type: "ping", ts: Date.now() }), 25000);

//         // 🔴 IMPORTANT: INIT with ONLY required profile + identity
//         safeSend({
//           type: "init",
//           user_id: user.user_id,
//           user_name: user.user_name,
//           profile: contextPayload, // ONLY 7 fields
//         });
//       };

//       ws.onmessage = async (evt) => {
//         setLastRaw(String(evt.data));

//         let textOut = null;
//         try {
//           const data = JSON.parse(evt.data);
//           if (data?.type === "typing") {
//             setTyping(true);
//             clearTimeout(typingTimer.current);
//             typingTimer.current = setTimeout(() => setTyping(false), 1500);
//             return;
//           }
//           if (typeof data === "string") textOut = data;
//           else if (data?.role && data?.content !== undefined) textOut = String(data.content);
//           else textOut = data?.message ?? data?.reply ?? data?.answer ?? data?.text;
//         } catch {
//           textOut = String(evt.data);
//         }

//         if (textOut != null) {
//           pushMsg({ role: "assistant", content: textOut });
//           try {
//             if (roomMeta?.id) {
//               await axios.post(
//                 `${apiBase}/edolutions/messages`,
//                 { room_id: roomMeta.id, user: "ai", message: textOut },
//                 { headers: { "Content-Type": "application/json" } }
//               );
//             }
//           } catch (e) {
//             console.error("save AI message failed:", e?.response?.status, e?.response?.data || e.message);
//           }
//         }
//       };

//       ws.onerror = (err) => setLastEvent({ type: "error", ts: Date.now(), err });

//       ws.onclose = (e) => {
//         clearInterval(heartbeat.current);
//         setStatus("disconnected");
//         setLastEvent({ type: "close", ts: Date.now(), code: e.code, reason: e.reason, wasClean: e.wasClean });

//         if (!manualClose.current) {
//           const next = Math.min(5, retryCount + 1);
//           setRetryCount(next);
//           const delay = Math.min(15000, 1000 * Math.pow(2, next - 1));
//           setTimeout(() => connect(), delay);
//         }
//       };
//     } catch (e) {
//       setStatus("disconnected");
//     }
//   }

//   function pushMsg({ role, content }) {
//     setMessages((prev) => [...prev, { id: `${Date.now()}-${Math.random()}`, role, content, ts: Date.now() }]);
//   }

//   function safeSend(obj) {
//     try {
//       const json = JSON.stringify(obj);
//       wsRef.current?.send(json);
//     } catch {}
//   }

//   async function sendUserMessage(text) {
//     if (!text.trim()) return;

//     // local echo
//     pushMsg({ role: "user", content: text });

//     // persist to Laravel
//     try {
//       if (roomMeta?.id) {
//         await axios.post(
//           `${apiBase}/edolutions/messages`,
//           { room_id: roomMeta.id, user: "user", message: text },
//           { headers: { "Content-Type": "application/json" } }
//         );
//       }
//     } catch (e) {
//       console.error("save user message failed:", e?.response?.status, e?.response?.data || e.message);
//     }

//     // 🔴 IMPORTANT: one clean envelope with text + identity
//     safeSend({
//       type: "user_message",
//       text: text,          // primary key most servers expect
//       message: text,       // secondary for backward-compat
//       user_id: user.user_id,
//       user_name: user.user_name,
//     });
//   }

//   function onSubmit(e) {
//     e.preventDefault();
//     if (initializing) return;
//     const text = value.trim();
//     if (!text) return;
//     setValue("");
//     sendUserMessage(text);
//   }

//   function forceReconnect() {
//     manualClose.current = false;
//     try {
//       wsRef.current?.close(1000, "Manual reconnect");
//     } catch {}
//     connect();
//   }

//   const quickPills = [
//     "Suggest a 30-day skill plan",
//     "Review my resume highlights",
//     "What roles fit my skills?",
//     "Mock interview: React + Node",
//   ];

//   return (
//     <div className="w-full h-[calc(80vh-0px)] overflow-hidden">
//       <div className="h-full max-w-5xl mx-auto px-3 sm:px-6">
//         <div className="relative h-full bg-white/80 backdrop-blur rounded-3xl shadow-xl border border-gray-100 overflow-hidden flex flex-col">
//           {/* Header */}
//           <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 sm:px-8 py-4 border-b bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white">
//             <div className="flex items-center gap-3">
//               <div className="w-10 h-10 rounded-full bg-white/20 flex items-center justify-center font-bold">AI</div>
//               <div>
//                 <p className="text-lg font-semibold leading-none">Cabil AI Mentor</p>
//               </div>
//             </div>
//             <div className="flex items-center gap-2">
//               <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold" style={{ background: "rgba(255,255,255,0.18)" }}>
//                 <span className={`mr-1.5 inline-block h-2 w-2 rounded-full ${status === "connected" ? "bg-green-300" : status === "connecting" ? "bg-yellow-300" : "bg-red-300"}`} />
//                 {status}{initializing ? " • loading room…" : ""}
//               </span>
//               <button onClick={forceReconnect} className="hidden sm:inline-flex text-xs font-semibold bg-white/20 hover:bg-white/30 active:scale-95 px-3 py-1.5 rounded-full">
//                 Reconnect
//               </button>
//             </div>
//           </div>

//           {/* Body */}
//           <div className="flex-1 flex flex-col min-h-0">
//             <div className="px-4 sm:px-8 pt-3">
//               <div className="flex max-md:hidden flex-wrap gap-2">
//                 {quickPills.map((q) => (
//                   <button
//                     key={q}
//                     onClick={() => {
//                       setValue(q);
//                       setTimeout(() => {
//                         sendUserMessage(q);
//                         setValue("");
//                       }, 10);
//                     }}
//                     className="text-xs sm:text-sm px-3 py-1.5 rounded-full border transition bg-white text-gray-800 border-gray-200 hover:border-[#EE5F2B] hover:text-[#2A3A54]"
//                     disabled={initializing}
//                   >
//                     {q}
//                   </button>
//                 ))}
//               </div>
//             </div>

//             <div ref={listRef} className="flex-1 overflow-y-auto px-3 sm:px-8 py-4 space-y-3 scroll-smooth">
//               {messages.map((m) => (
//                 <ChatBubble key={m.id} role={m.role} content={m.content} />
//               ))}
//               {typing && <TypingBubble />}
//             </div>

//             <form onSubmit={onSubmit} className="px-3 sm:px-6 pb-4">
//               <div className="flex items-end gap-2 bg-white rounded-2xl border border-gray-200 shadow-sm p-2">
//                 <textarea
//                   value={value}
//                   onChange={(e) => setValue(e.target.value)}
//                   rows={1}
//                   placeholder="Ask about careers, learning paths, resume tips…"
//                   className="flex-1 resize-none outline-none bg-transparent px-2 py-2 text-sm sm:text-base"
//                   onKeyDown={(e) => {
//                     if (e.key === "Enter" && !e.shiftKey) {
//                       e.preventDefault();
//                       onSubmit(e);
//                     }
//                   }}
//                   disabled={status !== "connected" || initializing}
//                 />
//                 <button
//                   type="submit"
//                   className="shrink-0 inline-flex items-center gap-2 text-white font-semibold px-4 py-2 rounded-xl shadow hover:opacity-95 disabled:opacity-60 bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
//                   disabled={status !== "connected" || initializing}
//                   title={status !== "connected" ? "Connecting…" : initializing ? "Loading room…" : "Send"}
//                 >
//                   <svg className="w-4 h-4 -ml-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
//                     <path d="M22 2L11 13" />
//                     <path d="M22 2L15 22L11 13L2 9L22 2Z" />
//                   </svg>
//                   <span className="hidden sm:inline">Send</span>
//                 </button>
//               </div>
//             </form>
//           </div>

//           {showDebug && (
//             <div className="absolute right-3 bottom-3 w-[min(520px,94%)] max-h-[65%] overflow-auto bg-white border border-gray-200 shadow-2xl rounded-2xl p-3">
//               <p className="text-sm font-semibold mb-2">Debug</p>
//               <div className="text-xs text-gray-600 space-y-1 mb-3">
//                 <div>WS: <code className="bg-gray-50 px-1 rounded">{wsUrl}</code></div>
//                 <div>Status: <b>{status}</b></div>
//                 <div>Retry: {retryCount}</div>
//                 <div>Last event: <code className="bg-gray-50 px-1 rounded">{JSON.stringify(lastEvent)}</code></div>
//                 <div className="mt-1">
//                   Last raw message:
//                   <pre className="mt-1 bg-gray-50 rounded p-2 max-h-36 overflow-auto">{lastRaw || "(none)"}</pre>
//                 </div>
//               </div>
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// function ChatBubble({ role, content }) {
//   const isUser = role === "user";
//   return (
//     <div className={`w-full flex ${isUser ? "justify-end" : "justify-start"}`}>
//       <div
//         className={`max-w-[88%] sm:max-w-[75%] rounded-2xl px-4 py-3 shadow ${
//           isUser ? "text-white rounded-br-sm bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" : "bg-white border border-gray-100 rounded-bl-sm"
//         }`}
//       >
//         {!isUser && <div className="text-[11px] font-semibold mb-1 text-[#2A3A54]">Cabil Mentor</div>}
//         <div className={`text-sm leading-relaxed whitespace-pre-wrap ${isUser ? "text-white" : "text-gray-800"}`}>{content}</div>
//       </div>
//     </div>
//   );
// }

// function TypingBubble() {
//   return (
//     <div className="w-full flex justify-start">
//       <div className="inline-flex items-center gap-1.5 bg-white border border-gray-100 rounded-2xl px-4 py-3 shadow">
//         {DOTS.map((i) => (
//           <span key={i} className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: `${i * 120}ms` }} />
//         ))}
//       </div>
//     </div>
//   );
// }


import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

/**
 * Sends ONLY the minimal profile object on open:
 * {
 *   name, user_type, degree_subject, university,
 *   experience, years_experience, skills[]
 * }
 * And user messages as: { type: "user_message", text }
 */

const DOTS = [0, 1, 2];

function slugify(s = "") {
  return String(s).toLowerCase().replace(/[^a-z0-9]+/g, "_").replace(/^_+|_+$/g, "");
}
function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

export default function CabilAIChat({
  user = {
    // user_id: "u123",
    // user_name: "Shayan",
    // profile: {
    //   name: "Syeda Mahnoor Navaid",
    //   user_type: "grad",                // "undergrad" | "grad" | "professional"
    //   degree_subject: "Computer Science",
    //   university: "karachi University",
    //   experience: "junior developer",
    //   years_experience: 2,
    //   skills: ["react", "nodejs", "mysql"],
    // },
  },
  wsBase = "wss://ai.cabil.co/ws/qa_chat",
  includeDateSuffix = false,
}) {
  const { t } = useTranslation();
  const apiBase = `${apiKey}/api`;

  const [messages, setMessages] = useState([
    {
      id: "hello",
      role: "assistant",
      content:
        "Hey! I’m your Cabil AI Mentor. Ask me anything about careers, skills, or your learning path. 😊",
      ts: Date.now(),
    },
  ]);
  const [value, setValue] = useState("");
  const [status, setStatus] = useState("disconnected");
  const [typing, setTyping] = useState(false);
  const [retryCount, setRetryCount] = useState(0);
  const [lastRaw, setLastRaw] = useState("");
  const [roomMeta, setRoomMeta] = useState(null);
  const [initializing, setInitializing] = useState(true);

  const wsRef = useRef(null);
  const listRef = useRef(null);
  const typingTimer = useRef(null);
  const manualClose = useRef(false);
  const heartbeat = useRef(null);

  const room = useMemo(() => {
    const uname = slugify(user?.user_name || "user");
    const uid = slugify(user?.user_id || "id");
    const dateSuffix = includeDateSuffix ? `_${todayISO()}` : "";
    return `cabil_${uname}_${uid}${dateSuffix}`;
  }, [user, includeDateSuffix]);

  // normalize type, map to ws path (professional -> pro)
  const rawType = (user?.profile?.user_type || "undergrad").toLowerCase();
  const normalizedType =
    rawType === "professional" ? "professional" : rawType === "grad" ? "grad" : "undergrad";
  const wsPath = normalizedType === "professional" ? "pro" : normalizedType; // undergrad|grad|pro
  const wsUrl = `${wsBase}/${wsPath}`;

  // EXACT minimal object your bot expects (no extras)
  const minimalProfile = useMemo(() => {
    const p = user?.profile || {};
    const skills = Array.isArray(p.skills)
      ? p.skills
      : String(p.skills || "")
          .split(",")
          .map(s => s.trim())
          .filter(Boolean);

    const years =
      typeof p.years_experience === "number"
        ? p.years_experience
        : parseInt(p.years_experience ?? 0, 10) || 0;

    return {
      name: p.name || user?.user_name || "",
      user_type: normalizedType,            // "undergrad" | "grad" | "professional"
      degree_subject: p.degree_subject || "",
      university: p.university || "",
      experience: p.experience || "",
      years_experience: years,
      skills,
    };
  }, [user, normalizedType]);

  // autoscroll only the messages list
  useEffect(() => {
    if (!listRef.current) return;
    listRef.current.scrollTop = listRef.current.scrollHeight;
  }, [messages, typing]);

  // create-or-get single room and load history
  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        setInitializing(true);
        const payload = { user_id: user.user_id, user_name: user.user_name };
        const { data } = await axios.post(`${apiBase}/edolutions/rooms/create`, payload, {
          headers: { "Content-Type": "application/json" },
        });
        if (!mounted) return;

        setRoomMeta(data.room || null);

        const hist = (data.messages || []).map(m => ({
          id: `db-${m.id}`,
          role: m.user === "user" ? "user" : "assistant",
          content: m.message,
          ts: new Date(m.created_at).getTime(),
        }));

        setMessages(prev => {
          const greet = prev.length === 1 && prev[0].id === "hello" ? prev : [];
          return [...greet, ...hist];
        });
      } catch (e) {
        console.error("createOrGet room failed:", e?.response?.status, e?.response?.data || e.message);
      } finally {
        setInitializing(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, [apiBase, user.user_id, user.user_name]);

  // websocket lifecycle
  useEffect(() => {
    if (!roomMeta) return;

    connect();
    return () => {
      manualClose.current = true;
      clearInterval(heartbeat.current);
      if (wsRef.current && wsRef.current.readyState === WebSocket.OPEN) {
        wsRef.current.close(1000, "Component unmount");
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [wsUrl, roomMeta?.id]);

  function connect() {
    manualClose.current = false;
    setStatus("connecting");

    try {
      const ws = new WebSocket(wsUrl);
      wsRef.current = ws;

      ws.onopen = () => {
        setStatus("connected");
        setRetryCount(0);

        clearInterval(heartbeat.current);
        heartbeat.current = setInterval(() => safeSend({ type: "ping", ts: Date.now() }), 25000);

        // ⬇️ Send EXACT minimal profile object (no wrapper)
        safeSend(minimalProfile);
      };

      ws.onmessage = async evt => {
        setLastRaw(String(evt.data));

        let textOut = null;
        try {
          const data = JSON.parse(evt.data);
          if (data?.type === "typing") {
            setTyping(true);
            clearTimeout(typingTimer.current);
            typingTimer.current = setTimeout(() => setTyping(false), 1500);
            return;
          }
          if (typeof data === "string") textOut = data;
          else if (data?.role && data?.content !== undefined) textOut = String(data.content);
          else textOut = data?.message ?? data?.reply ?? data?.answer ?? data?.text;
        } catch {
          textOut = String(evt.data);
        }

        if (textOut != null) {
          pushMsg({ role: "assistant", content: textOut });
          try {
            if (roomMeta?.id) {
              await axios.post(
                `${apiBase}/edolutions/messages`,
                { room_id: roomMeta.id, user: "ai", message: textOut },
                { headers: { "Content-Type": "application/json" } }
              );
            }
          } catch (e) {
            console.error("save AI message failed:", e?.response?.status, e?.response?.data || e.message);
          }
        }
      };

      ws.onerror = () => {};
      ws.onclose = e => {
        clearInterval(heartbeat.current);
        setStatus("disconnected");
        if (!manualClose.current) {
          const next = Math.min(5, retryCount + 1);
          setRetryCount(next);
          const delay = Math.min(15000, 1000 * Math.pow(2, next - 1));
          setTimeout(() => connect(), delay);
        }
      };
    } catch {
      setStatus("disconnected");
    }
  }

  function pushMsg({ role, content }) {
    setMessages(prev => [...prev, { id: `${Date.now()}-${Math.random()}`, role, content, ts: Date.now() }]);
  }

 function safeSend(payload) {
  try {
    if (typeof payload === "string") {
      // send as-is (no JSON.stringify)
      wsRef.current?.send(payload);
    } else {
      wsRef.current?.send(JSON.stringify(payload));
    }
  } catch {}
}

  async function sendUserMessage(text) {
    if (!text.trim()) return;

    // local echo
    pushMsg({ role: "user", content: text });

    // persist to Laravel
    try {
      if (roomMeta?.id) {
        await axios.post(
          `${apiBase}/edolutions/messages`,
          { room_id: roomMeta.id, user: "user", message: text },
          { headers: { "Content-Type": "application/json" } }
        );
      }
    } catch (e) {
      console.error("save user message failed:", e?.response?.status, e?.response?.data || e.message);
    }

    // ⬇️ One clean envelope to WS
   safeSend(text)
  }

  function onSubmit(e) {
    e.preventDefault();
    if (initializing) return;
    const text = value.trim();
    if (!text) return;
    setValue("");
    sendUserMessage(text);
  }

  return (
    <div className="w-full h-[calc(80vh-0px)] overflow-hidden">
      <div className="h-full max-w-5xl mx-auto px-3 sm:px-6">
        <div className="relative h-full bg-white/80 backdrop-blur rounded-3xl shadow-xl border border-gray-100 overflow-hidden flex flex-col">
          {/* Header */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-5 sm:px-8 py-4 border-b bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] text-white">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-white/20 grid place-items-center font-bold">AI</div>
              <p className="text-lg font-semibold leading-none">{t("adminDash.aichat.title")}</p>
            </div>
            <span className="inline-flex items-center px-2.5 py-1 rounded-full text-xs font-semibold" style={{ background: "rgba(255,255,255,0.18)" }}>
              <span className={`mr-1.5 inline-block h-2 w-2 rounded-full ${status === "connected" ? "bg-green-300" : status === "connecting" ? "bg-yellow-300" : "bg-red-300"}`} />
              {status}{initializing ? ` • ${t("adminDash.aichat.loadingRoom")}` : ""}
            </span>
          </div>

          {/* Body */}
          <div className="flex-1 flex flex-col min-h-0">
            <div ref={listRef} className="flex-1 overflow-y-auto px-3 sm:px-8 py-4 space-y-3 scroll-smooth">
              {messages.map(m => <ChatBubble key={m.id} role={m.role} content={m.content} />)}
              {typing && <TypingBubble />}
            </div>

            <form onSubmit={onSubmit} className="px-3 sm:px-6 pb-4">
              <div className="flex items-end gap-2 bg-white rounded-2xl border border-gray-200 shadow-sm p-2">
                <textarea
                  value={value}
                  onChange={e => setValue(e.target.value)}
                  rows={1}
                  placeholder={t("adminDash.aichat.placeholder")}
                  className="flex-1 resize-none outline-none bg-transparent px-2 py-2 text-sm sm:text-base"
                  onKeyDown={e => { if (e.key === "Enter" && !e.shiftKey) { e.preventDefault(); onSubmit(e); } }}
                  disabled={status !== "connected" || initializing}
                />
                <button
                  type="submit"
                  className="shrink-0 inline-flex items-center gap-2 text-white font-semibold px-4 py-2 rounded-xl shadow hover:opacity-95 disabled:opacity-60 bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
                  disabled={status !== "connected" || initializing}
                >
                  <svg className="w-4 h-4 -ml-0.5" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                    <path d="M22 2L11 13" />
                    <path d="M22 2L15 22L11 13L2 9L22 2Z" />
                  </svg>
                  <span className="hidden sm:inline">{t("adminDash.common.send")}</span>
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

function ChatBubble({ role, content }) {
  const { t } = useTranslation();
  const isUser = role === "user";
  return (
    <div className={`w-full flex ${isUser ? "justify-end" : "justify-start"}`}>
      <div className={`max-w-[88%] sm:max-w-[75%] rounded-2xl px-4 py-3 shadow ${isUser ? "text-white rounded-br-sm bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" : "bg-white border border-gray-100 rounded-bl-sm"}`}>
        {!isUser && <div className="text-[11px] font-semibold mb-1 text-[#2A3A54]">{t("adminDash.aichat.mentorLabel")}</div>}
        <div className={`text-sm leading-relaxed whitespace-pre-wrap ${isUser ? "text-white" : "text-gray-800"}`}>{content}</div>
      </div>
    </div>
  );
}

function TypingBubble() {
  return (
    <div className="w-full flex justify-start">
      <div className="inline-flex items-center gap-1.5 bg-white border border-gray-100 rounded-2xl px-4 py-3 shadow">
        {DOTS.map(i => <span key={i} className="w-2 h-2 rounded-full bg-gray-300 animate-bounce" style={{ animationDelay: `${i * 120}ms` }} />)}
      </div>
    </div>
  );
}
